<template>
  <div class="home contenido">
    <div class="container">
    <HeaderSeguros 
        msg="Individuos y familias"
        idea="El presente y el futuro es tuyo, cuando te olvidas de lo que pueda pasar y simplemente vives cada momento; cuenta con el respaldo y la certeza de nuestra asesoría ante cualquier riesgo."
        clase="individuos-y-familias"
     />
     <Titulo titulo="Preparate para vivir cada momento con estos planes" />
     <FotoTexto titulo="Autos" texto="Tu auto es una herramienta que te ayuda a conectar lugares, personas, negocios; te ayuda a ir por más, a crecer y a manejar tu tiempo.  Prepárate para el camino con nuestros distintos productos." linkURL="#tresPasos" textoURL="Contrata el seguro de tu auto" :imagen="imagen2" pos="fotoderecha"></FotoTexto>
     <FotoTexto titulo="Hogar" texto="Tu hogar más que tu casa, es tu mundo. Te ofrecemos una variedad de opciones para proteger tanto el patrimonio como a todos los que lo habitan, estén dentro o fuera de casa." linkURL="#tresPasos" textoURL="Contrata un seguro para tu hogar" :imagen="imagen3" pos="fotoizquierda"></FotoTexto>
     <FotoTexto titulo="Salud" texto="Un estado vital cambiante para todos de acuerdo a cada circunstancia de vida. Estamos preparados para ofrecerte protección que evoluciona; añade o resta coberturas, elige de acuerdo a tu necesidad y forma de ser." linkURL="#tresPasos" textoURL="Contrata un seguro de gastos médicos" :imagen="imagen4" pos="fotoderecha"></FotoTexto>
     <FotoTexto titulo="Accidentes" texto="La única forma de hacer frente a las eventualidades, es estar preparado para regresar lo más pronto y con menos daño, a nuestro día a día. Tenemos planes de atención médica y asistencia para todos." linkURL="#tresPasos" textoURL="Contrata un seguro de accidentes" :imagen="imagen5" pos="fotoizquierda"></FotoTexto>
     <FotoTexto titulo="Vida y Ahorro" texto="Más allá de pensar en el futuro, en las metas y objetivos, los planes de ahorro aprovechan nuestro presente para hacerlo crecer. Te ayudamos a lograr lo que te propongas." linkURL="#tresPasos" textoURL="Contrata un seguro de vida y/o ahorro" :imagen="imagen6" pos="fotoderecha"></FotoTexto>
  </div>
  <Trespasoscompleto />
</div>
</template>

<script>
// @ is an alias to /src
import HeaderSeguros from '@/components/HeaderSeguros.vue'
import Imagen from '@/assets/images/banner-header_01-individuos-y-familias.png'
import Titulo from '@/components/Titulo.vue'
import FotoTexto from '@/components/FotoTexto.vue'
import Imagen2 from '@/assets/images/pageinteriors_individuos-y-familias-01autos.jpg'
import Imagen3 from '@/assets/images/pageinteriors_individuos-y-familias-02hogar.jpg'
import Imagen4 from '@/assets/images/pageinteriors_individuos-y-familias-03salud.jpg'
import Imagen5 from '@/assets/images/pageinteriors_individuos-y-familias-04accidentes.jpg'
import Imagen6 from '@/assets/images/pageinteriors_individuos-y-familias-05vida-y-ahorro.jpg'
import Trespasoscompleto from '@/components/Trespasoscompleto.vue'
export default {
  name: 'IndividuosYfamilias',
  data() {
      return {
          imagen: Imagen,
          imagen2: Imagen2,
          imagen3: Imagen3,
          imagen4: Imagen4,
          imagen5: Imagen5,
          imagen6: Imagen6,
      }
  },
  components: {
    HeaderSeguros,
    Titulo,
    FotoTexto,
    Trespasoscompleto,
  },
  methods: {
      cambiaImagen: function(imagen){
          this.$store.commit('cambiaImagen', imagen);
      },
      muestraFooter: function(){
          this.$store.commit('muestraFooter');
      }
  },
  mounted: function(){
      console.log(Imagen);
      this.cambiaImagen(Imagen);
      this.muestraFooter();
      this.$store.commit('mideMenos', false);
      this.$store.commit('mideMas', false);
      this.$store.commit('estira', false);
  }
}
</script>
<style scoped>
.contenido {
    min-height: 500px;
}
@media only screen and (max-width: 1199px){
}
</style>
